import React, { useState } from 'react';

import { SendForm } from '../../Platform/SendForm';

export default function InvestSection() {
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    phone: '',
    message: '',
  });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === 'phone') {
      const validPhoneChars = /^[0-9()+\-\s]*$/;
      if (!validPhoneChars.test(value)) {
        return;
      }
    }

    setFormData({ ...formData, [name]: value });
    if (error) {
      setError('');
    }
  };

  const handleSubmit = async () => {
    const { fullName, email, phone } = formData;

    if (!fullName.trim() || !email.trim() || !phone.trim()) {
      setError('Please fill out all required fields.');
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setError('Please enter a valid email address.');
      return;
    }

    let data = {
      Name: formData.fullName,
      Mail: formData.email,
      Phone: formData.phone,
      Message: formData.message,
      Origin: 'Invest in Project',
    };

    try {
      await SendForm(data);
      setSuccess(true);
      setError('');
    } catch (error) {}
  };

  return (
    <div className='contact-us-section'>
      <div className='contact-us-inner-section'>
        <h2 className='section-title'>Invest in Project</h2>
        <div className='form-section'>
          <div className='input-group'>
            <label htmlFor='fullName'>Full name*</label>
            <input
              id='fullName'
              type='text'
              name='fullName'
              value={formData.fullName}
              onChange={handleChange}
            />
          </div>
          <div className='input-group'>
            <label htmlFor='email'>Email*</label>
            <input
              id='email'
              type='email'
              name='email'
              value={formData.email}
              onChange={handleChange}
            />
          </div>
          <div className='input-group'>
            <label htmlFor='phone'>Phone*</label>
            <input
              id='phone'
              type='tel'
              name='phone'
              value={formData.phone}
              onChange={handleChange}
            />
          </div>
          <div className='input-group'>
            <textarea
              id='message'
              name='message'
              placeholder='Message'
              rows='6'
              value={formData.message}
              onChange={handleChange}
            ></textarea>
          </div>
          {error && <p className='error-message'>{error}</p>}
          {success && (
            <p className='success-message'>
              Form successfully submitted, we will contact you
            </p>
          )}
          <button className='form-submit-btn' onClick={handleSubmit}>
            Invest
          </button>
        </div>
      </div>
    </div>
  );
}
